/**
 * Gets elements that have the same selector, finds the largest height among them, and resizes them all to that height
 *
 * Used for making sure individual review items are the same height so layout is uniform
 *
 * @param {string} selector - a DOM selector
 */
function matchElementHeights(selector) {
  const elementWrappers = document.querySelectorAll(selector);

  // get an array of element heights
  const largestElementHeight = [].map
    .call(elementWrappers, el => el.clientHeight)
    // get the largest one
    .reduce((a, b) => Math.max(a, b));

  // apply the largest height to each element
  [].forEach.call(
    elementWrappers,
    el => (el.style.height = `${largestElementHeight}px`)
  );
}

export default matchElementHeights;



// WEBPACK FOOTER //
// ./scripts/util/matchElementHeights.js